module.exports = __webpack_public_path__ + "static/media/Namra Joshi Resume 2024.1acf1d5c.pdf";